'use client';

import { MessageCircleQuestionMark } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Tooltip } from './Tooltip';

type QuestionsForUserBadgeProps = {
  // 러너 히스토리의 "### Questions for User" 섹션에 실제 질문이 남아 있는지 여부.
  // false면 아무것도 렌더하지 않아 호출부가 조건 분기를 따로 두지 않아도 된다.
  hasQuestions: boolean;
  size?: 'sm' | 'xs';
};

/**
 * "이 요청은 내 답을 기다린다"를 목록에서 알려주는 아이콘.
 *
 * 홈 최근 러너 위젯과 러너 요청 목록 페이지가 같은 개념을 다르게 보여주면 안 되므로
 * 아이콘·톤·문구를 이 컴포넌트 한 곳에 둔다. 판정 소스는 화면마다 다르지만
 * (목록은 linkedCoActionHistory 파싱, 홈은 서버가 준 hasQuestionsForUser 불리언)
 * 판정 규칙 자체는 @agentteams/core-constants 한 벌이다.
 *
 * 라벨 텍스트는 카드 한 줄을 밀지 않도록 화면에 그리지 않고, 스크린리더용 텍스트와
 * hover 툴팁으로만 노출한다.
 */
export const QuestionsForUserBadge = ({ hasQuestions, size = 'sm' }: QuestionsForUserBadgeProps) => {
  const tCommon = useTranslations('common');

  if (!hasQuestions) {
    return null;
  }

  return (
    <Tooltip
      content={tCommon('badges.questionsForUser.tooltip')}
      mode="overflowSafe"
      placement="top"
      className="shrink-0 text-[var(--color-warning)]"
    >
      <MessageCircleQuestionMark className={size === 'sm' ? 'size-3.5' : 'size-3'} aria-hidden="true" />
      <span className="sr-only">{tCommon('badges.questionsForUser.label')}</span>
    </Tooltip>
  );
};
